import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Accordion, Heading, Text } from '@frontend/design-system';

type Props = {
  subject?: string;
  body?: string;
  outcomeBubble?: ReactNode;
};

export const AiReasoningAccordion = ({ subject, body, outcomeBubble }: Props) => {
  const { t } = useTranslation('message-insights-panel');

  return (
    <Accordion.Item value='ai-reasoning'>
      <Accordion.Header>
        <span
          css={{
            display: 'flex',
            alignItems: 'center',
            columnGap: theme.spacing(1),
          }}
        >
          <Icon name='aiinfo' size={16} css={{ flexShrink: 0 }} />
          <Heading level={3}>{t('AI Reasoning')}</Heading>
        </span>
      </Accordion.Header>
      <Accordion.Body>
        <div
          css={{
            marginBottom: theme.spacing(2),
          }}
        >
          {!!subject ? (
            <>
              <Text css={{ marginBottom: theme.spacing(0.5) }} color='subdued'>
                {t('AI Message Outcome')}
              </Text>
              {outcomeBubble}
            </>
          ) : (
            <Text css={{ fontStyle: 'italic' }} color='subdued'>
              {t('No Outcome From This Message')}
            </Text>
          )}
        </div>
        <Text css={{ marginBottom: theme.spacing(0.5) }} color='subdued'>
          {t('Conversation Overview')}
        </Text>
        <div>{body}</div>
      </Accordion.Body>
    </Accordion.Item>
  );
};
